import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { zatca as ZatcaApi } from '@teem/constants/api';

@Injectable({
  providedIn: 'root'
})
export class ZatcaService {

  constructor(
    private httpClient: HttpClient
  ) { }

  public getAllInfo() {
    return this.httpClient.get(`${ZatcaApi.endPoint}`);
  }

  public getCertificate() {
    return this.httpClient.get(`${ZatcaApi.getCertificate}`);
  }

  public generateCertificate(params: any) {
    return this.httpClient.post(`${ZatcaApi.generateCertificate}`, params);
  }

  public requestingComplianceCertificate(params: any) {
    return this.httpClient.post(`${ZatcaApi.requestingComplianceCertificate}`, params);
  }

  public generatepProductionCertificate() {
    return this.httpClient.get(`${ZatcaApi.generatepProductionCertificate}`);
  }

  updateStatus(params: any) {
    return this.httpClient.put(`${ZatcaApi.updateStatus}`, params)
  }
}
